const consultancyData = [
    
        {
          id: 1,
          name: "PI: Rajendra R Sawant, CO-PI-1: Bhalchandra N Chaudhari; Co-PI-2: Y. S. Rao",
          title: "Design and Development of a fully automated Pressure and vacuum controlled Precision Induction Casting Machine",
          agency: "DST, Govt. India",
          amount: "70,20,723",
          duration: "3 Years (2022-23)",
          status: "Ongoing"
        },
        {
          id: 2,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and Development of 6kW Battery charger for Indian Railways",
          agency: "General Auto Electric Co. Mumbai",
          amount: "1,50,000",
          duration: "2022-23",
          status: "Ongoing"
        },
        {
          id: 3,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development of Solar Pumping BLDC Motor Controller",
          agency: "Sileaf Technologies, Pune",
          amount: "2,00,000",
          duration: "2022-23",
          status: "Ongoing"
        },
        {
          id: 4,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development of a fully automated Pressure and Vacuum Controlled Precision Induction Casting Machine",
          agency: "Riddhi Heatron Mumbai",
          amount: "1,00,000",
          duration: "2022-23",
          status: "Ongoing"
        },
        {
          id: 5,
          name: "Dr. Reena Sonkusare (PI), Dr. Rajendra Sawant (Co-PI) & Prof. Priya Deshpande (Co-PI)",
          title: "Development of Smart Energy Meter for Residential, Industrial and Commercial Applications.",
          agency: "KPEC Engineers & Contractors Pvt Ltd",
          amount: "200000",
          duration: "2022-23",
          status: "Ongoing"
        },
        {
          id: 6,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development Battery charging system of 4.5kW capacity",
          agency: "General Auto Electric Co. Mumbai",
          amount: "1,50,000",
          duration: "1 Year (2021-22)",
          status: "Completed"
        },
        {
          id: 7,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development of Solar Pumping BLDC Motor Controller",
          agency: "Sileaf Technologies, Pune",
          amount: "2,00,000",
          duration: "1 Year (2021-22)",
          status: "Completed"
        },
        {
          id: 8,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and Development of Induction Casting Application",
          agency: "Riddhi Heatron Mumbai",
          amount: "1,00,000",
          duration: "1 Year (2021-22)",
          status: "Completed"
        },
        {
          id: 9,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development of 6kW Battery Charger for Indian Railways",
          agency: "General Auto Electric Co. Mumbai",
          amount: "1,85,000",
          duration: "1 Year (2020-21)",
          status: "Completed"
        },
        {
          id: 10,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and development of Solar Pumping BLDC Motor Controller",
          agency: "Sileaf Technologies, Pune",
          amount: "2,00,000",
          duration: "1 Year (2020-21)",
          status: "Completed"
        },
        {
          id: 11,
          name: "Dr. Rajendra Sawant, Dr. Y. S. Rao",
          title: "Design and Development of Induction Casting Controller",
          agency: "Riddhi Heatron Mumbai",
          amount: "1,00,000",
          duration: "1 Year (2020-21)",
          status: "Completed"
        },
        {
          id: 12,
          name: "Dr. Y .S.Rao & Dr. R. R. Sawant",
          title: "Development of Software Applications to Maintain Service Calls and manage the service tickets/tokens",
          agency: "Suyog Telematics Mumbai",
          amount: "1,00,000",
          duration: "2 Years (2018-19)",
          status: "Completed"
        },
        {
          id: 13,
          name: "Dr. Y .S.Rao & Dr. R. R. Sawant",
          title: "Automative Battery Management System Automotive Private Limited",
          agency: "Zeuva",
          amount: "1,00,500",
          duration: "6 months (2018-19)",
          status: "Completed"
        },
        {
          id: 14,
          name: "Dr. Y .S.Rao & Dr. R. R. Sawant",
          title: "Design and Development of a 24V/15A DC Motor PWM drive for PMDC OR shunt DC Motor",
          agency: "Hardcarb Tech Pvt Ltd",
          amount: "1,85,000",
          duration: "4 month (2018-19)",
          status: "Completed"
        },
        {
          id: 15,
          name: "Dr. Y .S.Rao & Dr. R. R. Sawant",
          title: "Design and Development off Battery Charging System of 4.5 KW capacity",
          agency: "General Auto Electronic Corporation",
          amount: "1,50,000",
          duration: "4 month (2018-19)",
          status: "Completed"
        },
        {
          id: 16,
          name: "Dr. Y .S.Rao & Dr. R. R. Sawant",
          title: "Design and Development of Universal Controller for Solar Water Pumping",
          agency: "Sileaf Technologies Private Limited",
          amount: "2,00,000",
          duration: "6 month (2018-19)",
          status: "Completed"
        }
];
      
export default consultancyData;